export default __webpack_public_path__ + "static/media/NC.6c1fdb69.svg";